export * from './terms-and-conditions-config.service';
